import {makeAutoObservable} from "mobx";

/**
 * Ensures communication between components outside the chat context
 */
class ChatStore {
    userInputValue: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    setUserInputValue(userInputValue: string) {
        this.userInputValue = userInputValue;
    }
}

export default new ChatStore();
